// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"6dc5b7b0","236":"78388a6b","707":"9a5edd57"}[chunkId] + ".chunk.js";
};